import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import DashboardEmailConfigPage from '@/pages/dashboard/dashboard-email-config-page'

const emailConfigSearchSchema = z.object({
  fromSiteId: z.string().optional(),
})

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/email',
)({
  validateSearch: emailConfigSearchSchema,
  component: DashboardEmailConfigPage,
})
